
import { supabase } from '../../client';
import { EcomPaymentSettings } from '../types';
import { createDefaultPaymentSettings } from './createDefaultPaymentSettings';

/**
 * Récupère les paramètres de paiement pour une boutique
 * Si aucun paramètre n'existe, en crée un par défaut
 */
export async function getShopPaymentSettings(shopId: string): Promise<EcomPaymentSettings | null> {
  try {
    // Vérifier si des paramètres existent déjà
    const { data, error } = await supabase
      .from('ecom_payment_settings')
      .select('*')
      .eq('shop_id', shopId)
      .order('created_at', { ascending: false }) // Prendre le plus récent
      .limit(1)
      .single();

    if (error) {
      // Si l'enregistrement n'existe pas, le créer avec des valeurs par défaut
      if (error.code === 'PGRST116') {
        return await createDefaultPaymentSettings(shopId);
      }
      
      console.error('[getShopPaymentSettings] Error:', error);
      return null;
    }

    return data;
  } catch (error) {
    console.error('[getShopPaymentSettings] Exception:', error);
    return null;
  }
}
